import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {},
        content: {
            layerStyle: 'full-width',
            m: 'auto',
            textAlign: 'center',
            py: {base: 'small.base', sm: 'small.sm', md: 'medium.md', lg: 'medium.lg'},
            gap: {base: remCalc(16), md: remCalc(24)},
            bg: 'background.base.default',
            alignItems: 'center',
            justifyContent: 'center',
        },
        title: {
            textStyle: 'head-large',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        description: {
            textStyle: 'body-large',
            color: 'foreground.neutral.default',
            maxWidth: remCalc(640),
        },
    },
    variants: {
        black: {
            container: {
                backgroundColor: 'background.dark',
                color: 'foreground.neutral.inverse',
            },
        },
        grey: {
            container: {
                backgroundColor: 'background.light',
            },
        },
    },
}
